export const SettingsCopilotTrialFeaturesLearnMore = (): JSX.Element => {
  // TODO: Implement AX-821
  return (
    <div>
      The Agent co-pilot bundle empowers your team with cutting edge AI
      features, optimizing customer interactions
    </div>
  );
};
